<template>
  <section
    class="
      absolute
      bottom-16
      w-4/5
      desc
      flex flex-col
      items-center
      text-gray-100
      p-2
      z-50
    "
    :class="{ active: isActive }"
    @click="isActive = !isActive"
  >
    <h1
      class="text-2xl text-center w-full"
      @touchstart="touchstart"
      @touchmove="touchmove"
    >
      {{
        $i18n.locale == "en" && name.en
          ? name.en
          : $i18n.locale == "zh" && name.zh
          ? name.zh
          : $i18n.locale == "ja" && name.ja
          ? name.ja
          : $i18n.locale == "child" && name.child
          ? name.child
          : name.ko
      }}
    </h1>
    <span v-if="!isActive">더보기+</span>
    <span
      v-else
      class="mt-1 text-md whitespace-pre-line w-full"
      style="word-break: keep-all; word-wrap: break-word"
      >{{
        $i18n.locale == "en" && locale.en
          ? locale.en
          : $i18n.locale == "zh" && locale.zh
          ? locale.zh
          : $i18n.locale == "ja" && locale.ja
          ? locale.ja
          : $i18n.locale == "child" && locale.child
          ? locale.child
          : locale.ko
      }}</span
    >
  </section>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      default: () => {},
    },
    name: {
      type: Object,
      default: () => {},
    },
    locale: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      isActive: false,
      touchStart: 0,
      touchEnd: 0,
    };
  },
  methods: {
    touchstart(e) {
      this.touchStart = e.touches[0].clientY;
    },
    touchmove(e) {
      this.touchEnd = e.touches[0].clientY;
      if (this.touchStart > this.touchEnd) {
        this.isActive = true;
      } else {
        this.isActive = false;
      }
    },
  },
};
</script>

<style scoped>
.desc {
  height: 5rem;
  left: 50%;
  transform: translateX(-50%);
  border-top-left-radius: 1rem;
  border-top-right-radius: 1rem;
  background: rgba(0, 0, 0, 0.3);
  backdrop-filter: blur(4px);
  transition: all 0.3s ease-in;
}
.desc.active {
  height: 14rem;
}
.desc h1 {
  line-height: 1.5rem;
}
.desc.active span {
  max-height: 11rem;
  overflow-y: scroll;
}
</style>
